(function () {
  // Theme-Warenkorb-Store (Venue/zustand) verfügbar machen, damit Zähler + Drawer aktualisieren
  try { import('cart-store').then(function (m) { window.gbcCart = m && m.default; }).catch(function () {}); } catch (e) {}

  function refreshCart() {
    if (window.gbcCart && typeof window.gbcCart.refresh === 'function') {
      try { window.gbcCart.refresh(); } catch (e) {}
    }
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var n = cart.item_count;
        document.querySelectorAll('.cart-count-bubble items-count').forEach(function (el) { el.textContent = n; });
        document.querySelectorAll('.js-cart-icon').forEach(function (el) { el.classList.toggle('js-cart-full', n > 0); });
      }).catch(function () {});
  }

  document.querySelectorAll('.gbc').forEach(function (sec) {
    var grid = sec.querySelector('.gbc-grid');
    if (!grid) return;
    var noResult = sec.querySelector('.gbc-noresult');
    var state = { roest: '', prep: '' };

    function apply() {
      var visible = 0;
      sec.querySelectorAll('.gbc-card').forEach(function (card) {
        var okR = !state.roest || card.dataset.roest === state.roest;
        var okP = !state.prep || (card.dataset.prep || '').indexOf(state.prep) !== -1;
        var show = okR && okP;
        card.style.display = show ? '' : 'none';
        if (show) visible++;
      });
      if (noResult) noResult.style.display = visible ? 'none' : 'block';
    }

    sec.querySelectorAll('.gbc-chip').forEach(function (chip) {
      chip.addEventListener('click', function () {
        var f = chip.dataset.f, v = chip.dataset.v || '';
        var group = chip.parentNode;
        var wasActive = chip.classList.contains('active');
        group.querySelectorAll('.gbc-chip').forEach(function (c) { c.classList.remove('active'); });
        var next = (v === '' || wasActive) ? '' : v;
        state[f] = next;
        if (next === '') {
          var allChip = group.querySelector('.gbc-chip[data-v=""]');
          if (allChip) allChip.classList.add('active');
        } else {
          chip.classList.add('active');
        }
        apply();
      });
    });

    // Filter-Optionen ohne passende Produkte in dieser Kategorie ausblenden
    (function () {
      var allCards = Array.prototype.slice.call(sec.querySelectorAll('.gbc-card'));
      sec.querySelectorAll('.gbc-fgroup').forEach(function (group) {
        var visibleOpts = 0;
        group.querySelectorAll('.gbc-chip').forEach(function (chip) {
          var f = chip.dataset.f, v = chip.dataset.v || '';
          if (v === '') return;
          var match = allCards.some(function (card) {
            if (f === 'roest') return card.dataset.roest === v;
            return (card.dataset.prep || '').indexOf(v) !== -1;
          });
          if (!match) { chip.style.display = 'none'; } else { visibleOpts++; }
        });
        if (visibleOpts === 0) { group.style.display = 'none'; }
      });
    })();

    var sort = sec.querySelector('.gbc-sort');
    if (sort) {
      sort.addEventListener('change', function () {
        var v = sort.value;
        var cards = Array.prototype.slice.call(grid.querySelectorAll('.gbc-card'));
        cards.sort(function (a, b) {
          if (v === 'price-asc') return (a.dataset.price - b.dataset.price);
          if (v === 'price-desc') return (b.dataset.price - a.dataset.price);
          return (a.dataset.idx - b.dataset.idx);
        });
        cards.forEach(function (c) { grid.appendChild(c); });
      });
    }

    sec.querySelectorAll('.gbc-buy').forEach(function (form) {
      var variants = JSON.parse(form.querySelector('.gbc-vardata').textContent);
      var card = form.closest('.gbc-card');
      var abEl = card ? card.querySelector('.gbc-price__ab') : null;
      var kgEl = card ? card.querySelector('.gbc-price__kg') : null;
      var imgEl = card ? card.querySelector('.gbc-card__imgel') : null;
      var btn = form.querySelector('.gbc-addbtn');
      var btnOrig = btn ? btn.textContent : '';
      var sizesWrap = form.querySelector('.gbc-sizes');
      var sizeOpt = sizesWrap ? parseInt(sizesWrap.dataset.opt, 10) : -1;
      var grinds = Array.prototype.slice.call(form.querySelectorAll('.gbc-grind'));
      grinds.forEach(function (g) {
        g._all = Array.prototype.slice.call(g.options).map(function (o) { return { v: o.value, t: o.textContent }; });
      });
      function money(c) { return (c / 100).toFixed(2).replace('.', ',') + ' €'; }

      function activeSize() {
        if (!sizesWrap) return null;
        var a = sizesWrap.querySelector('.gbc-size.active:not([hidden])');
        return a ? a.dataset.val : null;
      }
      function selected() {
        var sel = [];
        if (sizesWrap) sel[sizeOpt] = activeSize();
        grinds.forEach(function (g) { sel[parseInt(g.dataset.opt, 10)] = g.value; });
        return sel;
      }
      function getVariant() {
        if (!sizesWrap && !grinds.length) { return variants.find(function (v) { return v.a; }) || variants[0]; }
        var sel = selected();
        return variants.find(function (v) { return v.o.every(function (x, i) { return x === sel[i]; }); });
      }

      // Größen ohne einzige verfügbare Variante ausblenden
      if (sizesWrap) {
        sizesWrap.querySelectorAll('.gbc-size').forEach(function (b) {
          var any = variants.some(function (v) { return v.o[sizeOpt] === b.dataset.val && v.a; });
          if (!any) { b.hidden = true; b.classList.remove('active'); }
        });
        if (!sizesWrap.querySelector('.gbc-size.active:not([hidden])')) {
          var first = sizesWrap.querySelector('.gbc-size:not([hidden])');
          if (first) first.classList.add('active');
        }
      }

      // Mahlgrad-Optionen auf die für die aktive Größe verfügbaren beschränken
      function rebuildGrinds() {
        var sz = activeSize();
        grinds.forEach(function (g) {
          var gOpt = parseInt(g.dataset.opt, 10);
          var prev = g.value;
          var allowed = g._all.filter(function (o) {
            return variants.some(function (v) {
              return v.a && (sz == null || v.o[sizeOpt] === sz) && v.o[gOpt] === o.v;
            });
          });
          if (!allowed.length) allowed = g._all;
          g.innerHTML = '';
          allowed.forEach(function (o) {
            var el = document.createElement('option');
            el.value = o.v; el.textContent = o.t;
            g.appendChild(el);
          });
          var keep = allowed.some(function (o) { return o.v === prev; });
          g.value = keep ? prev : allowed[0].v;
        });
      }

      function updatePrice() {
        var v = getVariant();
        if (btn) {
          if (!v || !v.a) { btn.disabled = true; btn.textContent = 'Ausverkauft'; }
          else if (btn.disabled && btn.textContent !== 'Hinzugefügt ✓') { btn.disabled = false; btn.textContent = btnOrig; }
        }
        if (!v) return;
        if (abEl) abEl.textContent = money(v.p);
        if (kgEl) {
          if (v.u && v.u > 0) {
            kgEl.textContent = money(v.u) + ' / ' + (v.rv && v.rv != 1 ? v.rv + ' ' : '') + (v.ru || 'kg');
            kgEl.style.display = '';
          } else {
            kgEl.style.display = 'none';
          }
        }
        if (imgEl && v.img) { imgEl.src = v.img; imgEl.removeAttribute('srcset'); }
      }

      form.querySelectorAll('.gbc-size').forEach(function (b) {
        b.addEventListener('click', function () {
          if (b.hidden) return;
          b.parentNode.querySelectorAll('.gbc-size').forEach(function (x) { x.classList.remove('active'); });
          b.classList.add('active');
          rebuildGrinds();
          updatePrice();
        });
      });
      grinds.forEach(function (g) { g.addEventListener('change', updatePrice); });

      rebuildGrinds();
      updatePrice();

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var variant = getVariant();
        if (!variant || !variant.a) { return; }
        var orig = btn.textContent;
        btn.disabled = true;
        fetch(form.dataset.url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: variant.id, quantity: 1 }] })
        }).then(function (r) { return r.json(); }).then(function (res) {
          if (res && res.status) { throw new Error(res.description || 'add-failed'); }
          btn.textContent = 'Hinzugefügt ✓';
          refreshCart();
          setTimeout(function () { btn.textContent = orig; btn.disabled = false; }, 1600);
        }).catch(function () { btn.textContent = 'Nicht möglich'; setTimeout(function () { btn.textContent = orig; btn.disabled = false; }, 1600); });
      });
    });
  });
})();
